// permission.js - 菜单权限与路由访问控制

import request from './request'

let allowedPathsCache = null

/**
 * 获取当前缓存的允许访问的菜单路径列表（来自 /menus/current）
 */
export function getAllowedPaths() {
  return allowedPathsCache
}

/**
 * 设置允许的路径缓存（Layout 拉取菜单后调用，避免路由守卫重复请求）
 */
export function setAllowedPaths(paths) {
  allowedPathsCache = Array.isArray(paths) ? paths : null
}

/**
 * 清除权限缓存（退出登录时调用）
 */
export function clearAllowedPaths() {
  allowedPathsCache = null
}

/**
 * 拉取当前用户菜单并缓存路径列表，供路由守卫使用
 * @returns {Promise<string[]>}
 */
export async function fetchAllowedPaths() {
  try {
    const res = await request.get('/menus/current')
    const menus = res && (res.data || res)
    const paths = Array.isArray(menus) ? menus.map(m => m.path).filter(Boolean) : []
    setAllowedPaths(paths)
    return paths
  } catch (e) {
    console.error('获取菜单权限失败', e)
    setAllowedPaths([])
    return []
  }
}

/**
 * 判断当前用户是否有权访问某路由路径
 * @param {string} routePath - 当前要访问的路由 path，如 /customers/recycle-bin
 * @param {string} [permissionPath] - 路由 meta.permissionPath，用于子页（如详情页用 /customers）
 * @returns {boolean}
 */
export function hasPathPermission(routePath, permissionPath) {
  const paths = getAllowedPaths()
  if (!paths || !paths.length) return false
  if (paths.includes(routePath)) return true
  if (permissionPath && paths.includes(permissionPath)) return true
  return false
}
